import React from 'react';
import { Link } from 'react-router-dom';

const SingleServiceThree = (props) => {
  const { itemClass, name, icon, title, description } = props;
  return (
    <div className={itemClass ? itemClass : 'it-service-3-item p-relative'}>
      <div className="it-service-3-name">
        <span data-text={name ? name : 'Dr.Williams'}>
          {name ? name : 'Dr.Williams'}
        </span>
      </div>
      <div className="it-service-3-icon">
        <span>
          <i className={icon ? icon : 'flaticon-refraction'}></i>
        </span>
      </div>
      <div className="it-service-3-content">
        <h4 className="it-service-3-title">
          <Link className="hover-anim tertiary" to="/service-details">
            {title ? title : 'Refractive Surgery'}
          </Link>
        </h4>
        <p>
          {description
            ? description
            : 'related to health and wellness category includes medical treatments'}
        </p>
      </div>
      <div className="it-service-3-arrow">
        <Link to="/service-details">
          <i className="fa-sharp fa-solid fa-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default SingleServiceThree;
